import { render, staticRenderFns } from "./InitializingDialog.vue?vue&type=template&id=96843f1c&scoped=true"
import script from "./InitializingDialog.vue?vue&type=script&lang=js"
export * from "./InitializingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96843f1c",
  null
  
)

export default component.exports